/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ max: NonNullable<unknown> }} Guidevideo_Error_Title_Too_Long1Inputs */

const vi_guidevideo_error_title_too_long1 = /** @type {(inputs: Guidevideo_Error_Title_Too_Long1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tiêu đề tối đa ${i?.max} ký tự`)
};

/**

* @param {Guidevideo_Error_Title_Too_Long1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const guidevideo_error_title_too_long1 = /** @type {((inputs: Guidevideo_Error_Title_Too_Long1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guidevideo_Error_Title_Too_Long1Inputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_guidevideo_error_title_too_long1(inputs)
});
export { guidevideo_error_title_too_long1 as "guideVideo_error_title_too_long" }